import React from "react";
import "../styles/ClubPage.css";
import { formatDate } from "../utils/dateUtils";


const UpcomingEvents = ({ clubData }) => {
    if (!clubData || !clubData.participations) return <p>Loading upcoming events...</p>;

    const today = new Date();

    // Filter upcoming events (date_start is in the future)
    const upcomingEvents = clubData.participations.filter(event => {
        if (!event.date_start || !event.date_start.seconds) {
            console.warn("Invalid date_start:", event);
            return false;
        }

        const eventStartDate = new Date(event.date_start.seconds * 1000);
        return eventStartDate >= today; // Future events only
    });

    return (
        <>
            <h2>Upcoming Events</h2>
            {upcomingEvents.length > 0 ? (
                upcomingEvents.map((event, index) => (
                    <div key={index} className="event-card">
                        {/* Ensure image URL is valid */}
                        {event.media?.length > 0 && event.media[0].startsWith("http") && (
                            <img className="event-image" src={event.media[0]} alt={event.name} />
                        )}

                        <h3>{event.name}</h3>
                        <p><strong>Date:</strong> {formatDate(event.date_start)}</p>
                        <p><strong>Location:</strong> {event.location}</p>
                    </div>
                ))
            ) : (
                <p>No upcoming events found.</p>
            )}
        </>
    );
};

export default UpcomingEvents;
